// extracted by mini-css-extract-plugin
export default {"SaveButton":"SaveButton_SaveButton__YFRoX","SaveButton__Caption":"SaveButton_SaveButton__Caption__pVoDk"};